import { Platform } from 'react-native';

import { isWeb } from '@/utils/constants-platform-specific';
import { isMobileBrowser } from '@/utils/is-mobile-browser/is-mobile-browser';

export type BetChannel = 'WEB' | 'MOBILE_WEB' | 'ANDROID' | 'IOS' | 'RETAIL' | 'OTHER';

/**
 * Returns the channel bets are placed from
 */
export const getChannel = (): BetChannel => {
    if (Platform.OS === 'ios') {
        return 'IOS';
    }
    if (Platform.OS === 'android') {
        return 'ANDROID';
    }
    if (isWeb) {
        if (isMobileBrowser()) {
            return 'MOBILE_WEB';
        } else {
            return 'WEB';
        }
    }
    return 'OTHER';
};
